import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Shipment } from 'services/action';
import { Page, Button } from 'ui/components';
import { UTCFormat } from 'utilities/common';
import { Shipments } from './component/form';

const initialState = {
  form: null,
  data: null,
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const [{ form, data }, setState] = React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(Shipment.$show(id, { load_shipment: true }));

    if (req?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        data: {
          ...req?.data,
          shipment: {
            ...req?.data?.shipment,
            unit_price: req?.data?.unit_price,
          },
        },
      }));
    }
  };

  const $handleFormChange = (v) => {
    setState((prevState) => ({ ...prevState, form: v }));
  };

  const $handleSubmit = async (e) => {
    const payload = {
      destination_id: form?.destination?.id,
      cod_value: form?.cod_value,
      unit_price: form?.unit_price,
      items: form?.items,
      eta_at: UTCFormat(form?.eta_at?.formatted, form?.eta_time, true),
      pickup_note: form?.pickup_note,
      instruction: form?.instruction,
      ref_code: form?.ref_code,
    };

    if (data?.order?.type === 'ftl') {
      payload.type = 'ftl';
      payload.origin_id = form?.origin?.id;
      payload.etd_at = UTCFormat(form?.etd_at?.formatted, form?.etd_time, true);
    } else {
      payload.type = 'ltl';
    }

    const req = await Dispatch(Shipment.$update(data?.id, payload));

    if (req?.message === 'success') {
      History.push(`/order/shipment/${data?.id}`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page type="form" className="col-md-10 bordered" onSubmit={$handleSubmit}>
      <Page.Header
        title="Perbaharui Shipment"
        className="bg-light bordered"
        backTo="/order/shipment"
      />

      <Page.Body className="row bordered">
        <Shipments
          customer={data?.order?.customer}
          service={data?.order?.service_type?.service}
          serviceType={data?.order?.service_type}
          data={data?.shipment}
          onInputChanges={$handleFormChange}
        />
      </Page.Body>
      <Page.Footer className="bg-light justify-content-center gap-md-2 pt-2 pb-3 mb-2 mb-md-0 border-top d-md-flex d-block flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/order/shipment`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
